export default (theme) => ({
    actions: {
        display: 'flex',
        gap: 12,
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    buttons: {
        display: 'flex',
        gap: 12,
        justifyContent: 'flex-end',
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        width: '100%',
    },
    summary: {
        alignItems: 'stretch',
        background: 'var(--background-utility025)',
        border: '1px solid var(--grey-100)',
        borderRadius: 8,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 12,
        justifyContent: 'flex-end',
        padding: 12,
    },
    summaryItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        minWidth: 120,
    },
    summaryItemEmphasis: {
        borderLeft: '1px solid var(--grey-100)',
        paddingLeft: 16,
    },
    status: {
        color: theme.colors.textLight.primary,
        minHeight: 20,
    },
    value: {
        display: 'block',
    },
    '@media (max-width: 760px)': {
        actions: {
            alignItems: 'stretch',
            flexDirection: 'column',
        },
        buttons: {
            width: '100%',
            '& > button': {
                flex: '1 1 0',
            },
        },
        summary: {
            flexDirection: 'column',
        },
        summaryItemEmphasis: {
            borderLeft: 0,
            borderTop: '1px solid var(--grey-100)',
            paddingLeft: 0,
            paddingTop: 12,
        },
    },
});
